module.exports = __webpack_public_path__ + "static/img/z7.f27338a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z7.png
// module id = 6vox
// module chunks = 2